<template>
  <div class="bg-secondary overflow-y-auto flex flex-shrink-0">
    <div>
      <div class="rounded border bg-grey border-secondary-lighter w-64 m-6">
        <img :src="imageUrl" alt />
      </div>

      <div v-if="photoData && photoData.first_name && photoData.last_name" class="m-6 mt-0 w-64 text-sm text-secondary-invert mr-4">
        Photo by
        <a :href="photoData.photographer_profile_link" class="underline font-bold" target="_blank">
          <span v-if="photoData.last_name">
            {{photoData.last_name }}
          </span>
          <span v-if="photoData.first_name">
            {{ photoData.first_name }}
          </span>
        </a>
        on
        <a href="https://unsplash.com/" class="underline font-bold" target="_blank">
          Unsplash
        </a>
      </div>

      <div class="m-6 mt-0 w-64">
        <div class="flex flex-row justify-center my-4">
          <span class="text-sm text-secondary-invert mr-4 flex items-center">
            {{$t('frontend_images_fix_ratio') }}
          </span>
          <gd-toggle v-model="fixRatio" />
        </div>

        <div class="flex flex-row justify-between mb-4">
          <div class="relative mr-2">
            <text-input v-model="width" data-cypress="gp-resizer-width" type="number" variant="dark"/>
            <span class="absolute right-0 top-0 text-secondary-invert text-sm h-full flex items-center mr-2">
              {{ $t('frontend_images_width_abbreviation') }}
            </span>
          </div>
          <div class="relative">
            <text-input v-model="height" type="number" variant="dark"/>
            <span class="absolute right-0 top-0 text-secondary-invert text-sm h-full flex items-center mr-2">
              {{ $t('frontend_images_height_abbreviation') }}
            </span>
          </div>
        </div>

        <div class="flex">
          <gd-button size="expand" @click="update()">
            {{ $t('frontend_images_update_dimensions') }}
          </gd-button>
        </div>

        <div class="flex justify-center mt-4">
          <a class="text-primary text-sm cursor-pointer" @click.prevent="deleteImage()">
            {{ $t('frontend_images_delete_image') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@groovepages/gd-lib/api';
import { gdImgProxy } from '../../utils';
import GdButton from '../Button';
import TextInput from '../TextInput';
import GdToggle from '../Toggle';

export default {
  components: { TextInput, GdButton, GdToggle },
  props: ['image', 'photoData'],
  data() {
    return {
      editor: null,
      height: null,
      width: null,
      fixRatio: true,
      ratio: 1,
      name: '',
    };
  },
  computed: {
    imageUrl() {
      return gdImgProxy({url:this.image});
    },
  },
  methods: {
    update() {
      this.editor.upload();
    },
    deleteImage() {
      api
        .delete(
          `${window.gdEnv.VUE_APP_API_URL}/groovedigital/images/delete/${btoa(
            this.image
          )}`
        )
        .then(() => {
          this.$emit('delete');
        });
    },
  },
};
</script>
